const { createApi } = require('@reduxjs/toolkit/dist/query/react');
const { rtkBaseQuery } = require('../helpers/rtkquery');

export const projectInfomationApi = createApi({
  reducerPath: 'projectInfomationApi',
  baseQuery: rtkBaseQuery('/ticket/'),
  tagTypes: ['Project', 'ProjectIndustri'],
  endpoints: (builder) => ({
    getProjectType: builder.query({
      query: () => '/Project/GetProjectTypes',
    }),
    getProjectTypeById: builder.query({
      query: (id) => ({
        url: `/Project/GetProjectTypeById?id=${id}`,
        method: 'GET',
      }),
    }),
    getProjectIndustries: builder.query({
      query: () => '/Project/GetProjectIndustries',
      providesTags: ['ProjectIndustri'],
    }),
    getProjectIndustryById: builder.query({
      query: (id) => ({
        url: `/Project/GetProjectIndustryById?id=${id}`,
        method: 'GET',
      }),
    }),
    getFinancingTypeProjects: builder.query({
      query: () => '/Project/GetFinancingTypeProjects',
    }),
    getFinancingTypeProjectById: builder.query({
      query: (id) => ({
        url: `/Project/GetFinancingTypeProjectById?id=${id}`,
        method: 'GET',
      }),
    }),
    getInitiativeCategories: builder.query({
      query: () => '/Project/GetInitiativeCategories',
    }),
    getProjectTags: builder.query({
      query: () => '/Project/GetTags',
    }),
    createProjectTag: builder.mutation({
      query: ({ name }) => ({
        url: `/Project/CreateTag?name=${encodeURIComponent(name)}`,
        method: 'POST',
      }),
    }),
    removeProjectTag: builder.mutation({
      query: (id) => ({
        url: `/Project/RemoveTag?id=${id}`,
        method: 'DELETE',
      }),
    }),
    deleteTagFromProject: builder.mutation({
      query: ({ projectId, tagId }) => ({
        url: `/Project/RemoveTagFromProject?projectId=${projectId}&tagId=${tagId}`,
        method: 'DELETE',
      }),
    }),
    addTagToProject: builder.mutation({
      query: ({ projectId, tagId }) => ({
        url: `/Project/AddTagToProject?projectId=${projectId}&tagId=${tagId}`,
        method: 'POST',
      }),
    }),
    createExpertConclusion: builder.mutation({
      query: (body) => ({
        url: '/ExpertConclusion/Create',
        method: 'POST',
        body,
      }),
    }),
    deleteExpertConclusion: builder.mutation({
      query: (id) => ({
        url: `/ExpertConclusion/Delete/${id}`,
        method: 'DELETE',
      }),
    }),
    createProjectIndustry: builder.mutation({
      query: ({ nameUz, nameRu }) => ({
        url: '/Project/CreateProjectIndustry',
        method: 'POST',
        responseHandler: (response) => response.text(),
        params: { nameUz, nameRu },
      }),
      invalidatesTags: ['ProjectIndustri'],
    }),
    updateProjectIndustry: builder.mutation({
      query: ({ id, nameUz, nameRu }) => ({
        url: `/Project/EditProjectIndustry?id=${id}`,
        method: 'PUT',
        responseHandler: (response) => response.text(),
        params: { id, nameUz, nameRu },
      }),
      invalidatesTags: ['ProjectIndustri'],
    }),
    deleteProjectIndustry: builder.mutation({
      query: (id) => ({
        url: `/Project/DeleteProjectIndustry?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['ProjectIndustri'],
    }),
    getProjectsPMList: builder.query({
      query: () => '/Project/GetProjectsPMList',
    }),
    filterWithFormProject: builder.mutation({
      query: (body) => ({
        url: '/Project/GetProjectPassportFilterList',
        method: 'POST',
        body,
      }),
    }),

    filterFormProject: builder.query({
      query: (body) => ({
        url: '/Project/GetProjectPassportFilterList',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetProjectTypeQuery,
  useLazyGetProjectTypeByIdQuery,
  useGetProjectIndustriesQuery,
  useLazyGetProjectIndustryByIdQuery,
  useGetFinancingTypeProjectsQuery,
  useLazyGetFinancingTypeProjectByIdQuery,
  useGetInitiativeCategoriesQuery,
  useGetProjectTagsQuery,
  useDeleteTagFromProjectMutation,
  useAddTagToProjectMutation,
  useCreateExpertConclusionMutation,
  useDeleteExpertConclusionMutation,
  useGetProjectsPMListQuery,
  useCreateProjectTagMutation,
  useRemoveProjectTagMutation,
  useCreateProjectIndustryMutation,
  useDeleteProjectIndustryMutation,
  useUpdateProjectIndustryMutation,
  useGetProjectIndustryByIdQuery,
  useFilterWithFormProjectMutation,
  useFilterFormProjectQuery,
} = projectInfomationApi;
